export default [
  {
    id: 'letterprofile',
    title: 'プロフィール',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'long_reason',
    title: '志望動機',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'preview-page-01'
  }
]
